<template>
  <div
    class="modal fade"
    id="ResellersDepositModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            id="resellers-deposit-close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("admins.deposit") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form
            id="upgradePlanForm"
            class="row g-4 mt-2"
            onsubmit="return false"
          >
            <div class="col-12">
              <label class="form-label">{{
                $t("accounts.deposit_date")
              }}</label>
              <input
                type="datetime-local"
                v-model="deposit.date"
                class="form-control"
              />
            </div>
            <div class="col-12">
              <label class="form-label">{{ $t("accounts.amount") }}</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="deposit.amount"
                  class="form-control"
                />
                <div class="input-group-text">{{ settings.currency }}</div>
              </div>
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-success me-2"
                type="button"
                @click="$emit('updated', deposit)"
              >
                <i class="ti ti-circle-plus me-1"></i>
                {{ $t("accounts.money.deposit") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "ResellersDeposit",
  props: {
    selectedAdmin: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["settings"]),
  },
  data() {
    return {
      deposit: {
        date: moment().format("YYYY-MM-DD HH:mm:ss"),
        amount: 0,
        admin_id: this.selectedAdmin.id,
      },
    };
  },
};
</script>
